export default "__VITE_ASSET__f73f0520__"